<div class="sort-direction">
  <span class="sort-direction__label">{{ label }}</span>
  <ng-container *ngTemplateOutlet="sortByTemplate"></ng-container>
  <button
    [attr.data-testid]="testIds.button"
    class="sort-direction__button"
    (click)="changeSelection()"
    [ngClass]="'sort-direction__button--' + align"
    [attr.aria-label]="'Sort direction: ' + getCurrentValueText()"
  >
    <span class="sort-direction__text" [attr.data-testid]="testIds.text">{{ getCurrentValueText() }}</span>
    <ftr-icon [icon]="getCurrentValueIcon()" align="Middle" color="Primary" size="Medium"></ftr-icon>
  </button>
</div>
